import React from "react";
import { CircleCheckIcon, CircleXIcon } from "lucide-react";
import { afterList, beforeList } from "../../data/content";
import { SectionHeading } from "../ui/SectionHeading";
import { CtaButton } from "../ui/CtaButton";
export function BeforeAfterSection() {
  return <section className="bg-paper px-5 py-16 sm:py-24" data-id="element-21" data-mp="3feka3x3konm6">
      <div className="mx-auto max-w-5xl" data-id="element-22" data-mp="3ff2exi4awa5p">
        <SectionHeading title="The Difference a Clear Structure Makes" data-id="element-23" data-mp="6yqr9blrr01y" />
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-24" data-mp="6zimglbgevrp">
          <div className="overflow-hidden rounded-3xl border-2 border-danger/25 bg-dangersoft" data-id="element-25" data-mp="by3hm6bump9a">
            <h3 className="bg-danger px-5 py-4 text-center text-lg font-extrabold uppercase tracking-wide text-white" data-id="element-26" data-mp="3tf3emu8txbjl">
              Before Endo Blueprint™
            </h3>
            <ul className="space-y-4 p-5 sm:p-6" data-id="element-27" data-mp="pxuzwj9eert3">
              {beforeList.map(item => <li key={item} className="flex gap-3 text-[17px] leading-snug text-ink" data-id="element-28" data-mp="uobdq4h4sffz">
                  <CircleXIcon className="mt-0.5 h-6 w-6 shrink-0 text-danger" aria-hidden="true" data-id="element-29" data-mp="uq625srm2pot" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="overflow-hidden rounded-3xl border-2 border-cta/40 bg-navy" data-id="element-30" data-mp="1xn6pwfnp0bex">
            <h3 className="bg-cta px-5 py-4 text-center text-lg font-extrabold uppercase tracking-wide text-white" data-id="element-31" data-mp="2cf8olwe10ydd">
              With Endo Blueprint™
            </h3>
            <ul className="space-y-4 p-5 sm:p-6" data-id="element-32" data-mp="2ldkhk52d888z">
              {afterList.map(item => <li key={item} className="flex gap-3 text-[17px] leading-snug text-white" data-id="element-33" data-mp="2gehf8sdrsg4p">
                  <CircleCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-[#4ADE80]" aria-hidden="true" data-id="element-34" data-mp="2vd1pkt53ay84" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
        <div className="mt-12" data-id="element-35" data-mp="10zse4vszh2n8">
          <CtaButton label="Yes, I Want the Endo Blueprint™" size="md" data-id="element-36" data-mp="110v1itr3kmye" />
        </div>
      </div>
    </section>;
}